import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import history from "../../../../../libs/history";
import "./CategoriesModeTinder.scss";
import {
    fetchCategoriesModeTinder,
    resetCategoriesModeTinder
} from "../../../../../creators/tagModerations.categoriesModeTinder";
import {LoadingBar} from "../../../../components/Loader";
import {Button} from "../../../../components/Button";


class CategoriesModeTinder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayCategory : 0
        }

        this.props.fetchCategoriesModeTinder({displayModeTinder:true, type : this.props.type});
    }

    componentWillUnmount() {
        this.props.resetCategoriesModeTinder();
    }


    render() {

        return !this.props.categoriesModeTinderInitialized ? <LoadingBar /> : (
            <div className={"categories-tinder"}>
                {this.props.categoriesModeTinder.filter(category => category.totalModeration > 0).map(category =>{
                    return (<div className={"categories"} key={category._id}>
                        <div className={"category-title"} onClick={()=> this.props.handleDisplayCategory(category.slug === this.props.displayCategory ? "" : category.slug)}>{category.title}</div>
                        <div className={`category-subcat ${category.slug.toString() === this.props.displayCategory ? "active" : ""}`}>
                            {category.childrens.filter(subCategory => subCategory.totalModeration > 0).map(subCategory =>(
                                <Button
                                    key={subCategory._id}
                                    className="btn-category"
                                    btnStyle={"primary"}
                                    size={"small"}
                                    content={`${subCategory.title} ( ${subCategory.totalModeration || 0} medias)`}
                                    onClick={() => {history.push(`${this.props.currentUrl}-photo/${subCategory._id.toString()}`)}}/>
                            ))}
                        </div>
                    </div>)
                })}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        categoriesModeTinder: state.categoriesModeTinder.data,
        categoriesModeTinderInitialized : state.categoriesModeTinder.initialized,
        categoriesModeTinderLoading : state.categoriesModeTinder.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoriesModeTinder,
    resetCategoriesModeTinder
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesModeTinder);